/**
* Products - Index
*/
(function ($) {
  $(document).on('turbolinks:load', () => {
    // Only run this on `.products.index` page.
    if (!document.querySelector('.products.index')) {
      return
    }

    addProductTracking()
  })

  /**
  * @function addProductTracking
  *
  * Sets up the products in the products/search results list to be tracked using
  * the tracking plugin.
  */
  function addProductTracking() {
    let listName


    const displayType = sessionStorage.getItem('products-display-type') || 'grid'


    let $list


    const $productList = $('[data-hook="homepage_products"]')


    const $searchList = $('[data-hook="search_results"]')

    // Figure out if the page is for search results or not.
    if ($productList.length) {
      $list = $productList
      listName = `${$productList.data('list-name')}: ${displayType}`
    } else if ($searchList.length) {
      $list = $searchList
      listName = `${$searchList.data('list-name')}: ${displayType}`
    } else {
      return
    }
    // Track impressions
    $list.track({
      type: 'product impression',
      selector: '.product',
      list: listName,
    })
  }
}(jQuery))
